import React from 'react';
import Link from '../../../components/LocalizedLink';

const karavan = {
  "karavan.pealkiri": "Karavanid & telkimine",
  "karavan.blokk1": () => (
    <>
      <h2 className="title is-2">Karavanid & telkimine Varbla puhkekülas</h2>
      <p>
        Suurepärane loodus lummab ja kutsub meie juurde puhkama ka karavanidega
        seiklejaid ning rännumehi, kes peavad lugu telkimisest.
      </p>
      <p>
        Karavaniplats võimaldab vastu võtta kuni 20 autokaravani ning rohkelt
        telkijaid, kes kõik saavad end sisse seada vaid 100-150m kaugusel merest
        ja liivarannast.
      </p>
      <p>
        Linnakärast eemal, privaatse ja puutumatu looduse rüpes on mõnus
        lõõgastuda, nautida saunamõnusid, või paadiga aerutada vastu
        päikeseloojangule
      </p>
      <p>
        Maitsvat kehakinnitust pakume motelli{" "}
        <Link to="/toitlustus">pubiruumis</Link> või{" "}
        <Link to="/sadam">sadama</Link> uues restoranis.
      </p>
    </>
  ),
  "karavan.hinnakiri": () => (
    <>
      <div className="columns">
        <div className="column">
          <h5 className="title is-5">Karavanikoht</h5>
          <p>1 ööpäev 25€</p>
          <p>Hind sisaldab:</p>
          <p>
            karavanis 2 inimest, elekter, vesi, WC ja dušširuumi kasutus,
            väli-grillimaja kasutus.
          </p>
        </div>
        <div className="column">
          <h5 className="title is-5">Telkimine</h5>
          <p>1 ööpäev - 10€/inimene</p>
          <p>Hind sisaldab:</p>
          <p>
            WC ja dušširuumi kasutus, elektri kasutamise võimalus, grillimise
            võimalus
          </p>
        </div>
      </div>
      <br />
      <h5 className="title is-5">Täiendavad kulud</h5>
      <p>lisa täiskasvanu: 3€/ööp.</p>
      <p>lisa laps 7. kuni 12.a. - 2€/ööp.</p>
      <p>alla 7.a. laps - tasuta</p>
      <br />
      <h5 className="title is-5">MUUD TEENUSED</h5>
      <p>Hommikusöök - 10€/inim</p>
      <p>pesumasina kasutus: 4€/masinatäis</p>
      <p>Jalgrattarent - 15€/päev, 3€/h</p>
      <p>Käterätt-saunalina - 2€</p>
      <p>paadirent - 7€/h või 25€/päev</p>
      <p>Motelli sauna kasutus - 25€/h + 2€ inim.</p>
      <p>Dušširuumi kasutus - 3€ inim.</p>
      <p>Kümblustünni kasutus - 75€/ päev</p>
      <p>Tünnisaun - 175€/päev</p>
      <p>Sup-lauarent - 50€/päev</p>
    </>
  ),
};

export default karavan;
